// @ts-nocheck
import { flow, Instance, types, getRoot } from 'mobx-state-tree';
import { Secretariat } from './models/Secretariat';
import { getEnvironment } from './utils';
import { getBaseStore } from './BaseStore';
import { ApplicationStore } from './ApplicationStore';
import { Page } from '../common/enums';
import { RootStoreType } from './RootStore';

interface SearchSecretariatCriteria {
  secretariatId?: number;
  name?: string;
  code?: string;
  isActive?: boolean;
}

export const SecretariatStore = types
  .compose(
    getBaseStore<Instance<typeof Secretariat>, Instance<typeof Secretariat>>(
      Secretariat,
      'secretariatId',
      'secretariat',
    ),
    types.model('SecretariatStore', { selectedSecretariatId: types.optional(types.number, () => 0) }),
  )
  .views((self) => ({
    getByIdOrNew(id: number) {
      if (id > 0) {
        return self.datas.get(id.toString());
      } else {
        return {
          pharmacyId: undefined,
          isContributing: true,
          isActive: true,
          receivesSms: true,
        };
      }
    },
  }))
  .actions((self) => {
    const env = getEnvironment(self);
    const root: RootStoreType = getRoot(self);

    const saveSecretariat = flow(function*(secretariat: Instance<typeof Secretariat>) {
      const res = yield self.saveElement(secretariat);
      // @ts-ignore
      if (secretariat.secretariatId !== res.secretariatId) {
        (root.ApplicationStore as Instance<typeof ApplicationStore>).navigate(
          // @ts-ignore
          `${Page.SecretariatPage}/${res.secretariatId}`,
        );
      }
    });

    const setSelectedSecretariat = flow(function*(secretariat: Instance<typeof Secretariat> | undefined) {
      if (secretariat === undefined) {
        self.selectedSecretariatId = undefined;
      } else self.selectedSecretariatId = secretariat.secretariatId;
    });

    
    return { 
      afterAttach: flow(function*() {
        yield self.loadList();
      }),
      saveSecretariat, setSelectedSecretariat };
  });
